import { APP_STORAGE } from "../_Config/AppConfig.Storage";

const ENV_TRUE = (value, fallback = true) => {
    if (value === undefined || value === null || value === "") return fallback;
    return String(value).trim().toLowerCase() === "true";
};

// NOTEBOOK es una herramienta privada propia: por defecto la autenticación
// persiste entre cierres del navegador. Se puede revertir por .env sin tocar código.
export const AUTH_PERSIST_SESSION = ENV_TRUE(process.env.REACT_APP_AUTH_PERSIST_SESSION, true);

export const STORAGE_SESSION_HELPER = {

    GET_STORAGE: (key) => {
        return sessionStorage.getItem(key) || localStorage.getItem(key);
    },

    SET_STORAGE: (key, value) => {
        localStorage.setItem(key, value);
    },

    GET_AUTH_STORAGE: (key) => {
        if (AUTH_PERSIST_SESSION) {
            const PERSISTED = localStorage.getItem(key);
            if (PERSISTED) return PERSISTED;

            // Migra automáticamente sesiones creadas por versiones anteriores.
            const LEGACY_SESSION = sessionStorage.getItem(key);
            if (!LEGACY_SESSION) return null;

            localStorage.setItem(key, LEGACY_SESSION);
            sessionStorage.removeItem(key);
            return LEGACY_SESSION;
        }

        const SESSION = sessionStorage.getItem(key);
        if (SESSION) return SESSION;

        const LEGACY_PERSISTED = localStorage.getItem(key);
        if (!LEGACY_PERSISTED) return null;

        sessionStorage.setItem(key, LEGACY_PERSISTED);
        localStorage.removeItem(key);
        return LEGACY_PERSISTED;
    },

    SET_AUTH_STORAGE: (key, value) => {
        if (AUTH_PERSIST_SESSION) {
            sessionStorage.removeItem(key);
            localStorage.setItem(key, value);
            return;
        }

        localStorage.removeItem(key);
        sessionStorage.setItem(key, value);
    },

    SET_SESSION_STORAGE: (key, value) => {
        sessionStorage.setItem(key, value);
    },

    REMOVE_STORAGE: (key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    },

    // Sólo se invoca desde el cierre de sesión explícito o si el proyecto
    // decide habilitar REACT_APP_AUTH_LOGOUT_ON_401=true.
    CLEAR_AUTH: () => {
        [
            APP_STORAGE.TOKEN_USER_AUTH,
            APP_STORAGE.TOKEN_USER_REFRESH,
            APP_STORAGE.AUTH_VERIFY_EMAIL,
            APP_STORAGE.TEMP_EMAIL_VERIFY,
        ].filter(Boolean).forEach((key) => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
    }

};
